import PropTypes from 'prop-types';
import React from 'react';
import { Generic } from 'app/components/shared/GenericMessage';

export default function GenericForm(props) {
  return !props.fieldErrors || props.fieldErrors.isEmpty() ? <Generic {...props} /> : null;
}

GenericForm.propTypes = {
  fieldErrors: PropTypes.objectOf(
    PropTypes.shape({
      classification: PropTypes.string,
      message: PropTypes.string
    })
  )
};
